import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type FormFieldLabelProps = {
  label: ReactNode;
  optional?: boolean;
  children?: ReactNode;
  className?: string;
};

export function FormFieldLabel({
  label,
  optional = false,
  children,
  className = "",
}: FormFieldLabelProps) {
  const { t } = useTranslation();
  return (
    <span className={`block text-sm font-medium text-slate-700 dark:text-slate-300 ${className}`.trim()}>
      {label}
      {optional ? (
        <span className="ml-1 font-normal text-slate-400 dark:text-slate-500">
          {t("forms.field.optional_label")}
        </span>
      ) : null}
      {children}
    </span>
  );
}
